import DashboardConfiguration from "components/shared/DashboardConfiguration/DashboardConfiguration";
import Alarms from "pages/alarms/Alarms";
import AllAssets from "pages/all-assets/AllAssets";
import ExpressionContainer from "pages/expressions/ExpressionContainer";
import TagContainer from "pages/tags/TagContainer";
import TagTypeContainer from "pages/tag-types/TagTypeContainer";
import TicketsContainer from "pages/tickets/TicketsContainer";
import Documents from "pages/documents/Documents";
import UnityContainer from "pages/unity";
import { Navigate, Route, Routes } from "react-router-dom";
import { AuthGuard } from "utilities/AuthGuard";
import "./App.css";
import UsersContainer from "pages/users/UsersContainer";
import Header from "components/layout/Header/Header";
import HealthContainer from "pages/HealthCheck";
import Logs from "pages/Logs";
import watermarkBg from "assets/watermarkBg.png";
import { Layout } from "processhub-components-lib";
import TabsDashboard from "pages/Dashboard/AllDynamicTabs/TabsDashboard";
import { Modal, MinifiedMenu, HealthModal } from "processhub-components-lib";
import { useContext, useState, useEffect } from "react";
import { ModalContext } from "hooks/ModalProvider";
import { useMinifiedMenu } from "hooks/useMinifiedMenu";
import { useAiChat } from "hooks/AiChatContext";
import AiChat from "components/AiChat/AiChat";
import allHooks from "hooks";
import modalConfig from "config/modal/modalConfig";
import healthCheckApiConfig from "config/modal/healthCheckApiConfig";
import InactivityReloader from "utilities/InactivityReloader";
import Authorization from "pages/Authorization/Authorization";
import ServerModal from "components/StaticDashboard/ServerModal/ServerModal";
import SRACModal from "components/StaticDashboard/SRACModal/SRACModal";

function App() {
  const { serversModalShown, setServersModalShown, cracModalShown } = useContext(ModalContext);
  const isLoading = false;
  const [selectedTag, setSelectedTag] = useState<any>({
    action: "",
    value: null,
  });
  const [isMovementDisabled, setIsMovementDisabled] = useState(0);
  const { modalType, setModalType, setShowProjects, setCracModalShown } = useContext(ModalContext);
  const [showHealth, setShowHealth] = useState(false);
  const {
    setMinifiedMenuOpen,
    addItemToPosition,
  } = useMinifiedMenu();

  useEffect(() => {
    if (modalType === '' || modalType === 'report') {
      setMinifiedMenuOpen(true);
    }
    if (modalType !== '' && modalType !== 'report') {
      setMinifiedMenuOpen(false);
    }
    setSelectedTag({
      action: modalType,
      value: null,
    });
  }, [modalType]);
  const refresh = async () => { };
  const { aiChatShown } = useAiChat();

  // const { aiChatShown } = useAiChat();
  const [menuVisibilityParams, setMenuVisibilityParams] = useState({ left: true, right: true });

  useEffect(() => {
    if (selectedTag.action !== '') {
      setIsMovementDisabled(1);
    }
    else {
      setIsMovementDisabled(0);
    }
  }, [selectedTag]);

  const genModalItems = (mode: 'note' | 'bubble' | 'preview' | 'chart' | 'widget' | 'label' | 'doc' | 'pins' | 'measurements' | 'aiChat', data: any, position: 'left' | 'right') => {
    if (mode === 'aiChat') {
      return (
        <div className="h-full w-full bg-gray/70">
          <AiChat setIsMovementDisabled={setIsMovementDisabled} />
        </div>
      );
    }
    return null;
  };

  return (
    <>
      <InactivityReloader />
      <Routes>
        <Route path="/login" element={<Authorization />} />
        <Route element={<AuthGuard />}>
          <Route element={<Layout><Header setShowProjects={setShowProjects} setShowHealth={setShowHealth} /></Layout>}>
            <Route path="/new-dashboard" element={<TabsDashboard />} />
            <Route path="/" element={<Navigate to="/dashboard" />} />
            <Route path="/3d-dashboard" element={<UnityContainer />} />
            <Route path="/dashboard" element={<TabsDashboard />} />
            <Route path="/dashboard-configuration">
              <Route element={<DashboardConfiguration />}>
                <Route
                  index
                  element={<Navigate to="/dashboard-configuration/tags" />}
                />
                <Route path="tags" element={<TagContainer />} />
                <Route path="tag-type" element={<TagTypeContainer />} />
                <Route path="expressions" element={<ExpressionContainer />} />
                <Route path="documents" element={<Documents />} />
                <Route path="all-assets" element={<AllAssets />} />
              </Route>
            </Route>
            <Route path="/alarms" element={<Alarms />} />
            <Route path="/tickets" element={<TicketsContainer />} />
            <Route path="/users" element={<UsersContainer />} />
            <Route path="/logs" element={<Logs />} />
            <Route path="/health" element={<HealthContainer />} />
          </Route>
        </Route>
        <Route path="*" element={<p>Not Found</p>} />
      </Routes>
      <Modal hasPointClouds={false} page="tags" setModalType={setModalType} isLoading={isLoading} refresh={refresh} selectedTag={selectedTag} setSelectedTag={setSelectedTag} modalConfig={modalConfig} hooks={allHooks} theme="sdaia" />
      {
        aiChatShown && !location.pathname.endsWith('/3d-dashboard') &&
        <div className="h-screen w-screen absolute top-0 left-0 z-50 overflow-hidden pointer-events-none">
          <div className="relative h-full w-full">
            <div className="pointer-events-auto">
              <MinifiedMenu genModalItems={genModalItems} allHooks={allHooks} visibilityParams={menuVisibilityParams} setVisibilityParams={setMenuVisibilityParams} />
            </div>
          </div>
        </div>
      }
      {
        showHealth &&
        <div className="absolute left-0 top-0 w-screen h-screen bg-dark/35 flex items-center justify-center align-middle" onClick={() => setShowHealth(false)}>
          <div className="w-[85%] h-[85%] mt-10 z-50 flex items-center justify-center">
            <HealthModal setShowHealth={setShowHealth} healthCheckApiConfig={healthCheckApiConfig} />
          </div>
        </div>
      }
      {serversModalShown && <ServerModal />}
      {cracModalShown && <SRACModal />}
    </>
  );
}

export default App;
